import { DemandRoleSummary } from 'components/organisms/resource-management/common-types/demand';
import {
  DemandRoleEvent,
  SchedulerEventType,
} from 'components/organisms/resource-management/event-types';
import { SchedulerResourceType } from 'components/organisms/resource-management/resource-types';
import { getTotalAllocatedMinutes } from '../../common';
import { resourceIdForDemandResource } from '../../id';
import {
  getClassNameBasedOnAllocatedPercentage,
  getSchedulerEventProps,
  getSchedulerEventsClass,
} from '../common';
import { idForDemandEvent } from './common';

const getClassNameForDemandRoleSummary = ({
  usersAllocatedMinutes,
  teamsAllocatedMinutes,
  capacity,
}: DemandRoleSummary): string => {
  const totalMinutes =
    getTotalAllocatedMinutes(usersAllocatedMinutes) +
    getTotalAllocatedMinutes(teamsAllocatedMinutes);
  const className = capacity === 0 ? 'no-capacity' : '';
  const allocatedPercentage =
    capacity === 0 ? 0 : Math.round((totalMinutes / capacity) * 100);

  return getClassNameBasedOnAllocatedPercentage(allocatedPercentage, className);
};

export const asDemandRoleSummaryEvent = (
  roleSummary: DemandRoleSummary,
): DemandRoleEvent => ({
  type: SchedulerEventType.DemandRole,
  resourceId: resourceIdForDemandResource(
    roleSummary.roleId,
    SchedulerResourceType.DemandRole,
  ),
  id: idForDemandEvent(
    SchedulerEventType.DemandRole,
    roleSummary.roleId,
    roleSummary.startDate,
    roleSummary.forViewPreset,
  ),
  startDate: roleSummary.startDate.toDate(),
  endDate: roleSummary.endDate.toDate(),
  roleId: roleSummary.roleId,
  capacity: roleSummary.capacity,
  usersAllocatedMinutes: roleSummary.usersAllocatedMinutes,
  teamsAllocatedMinutes: roleSummary.teamsAllocatedMinutes,
  forViewPreset: roleSummary.forViewPreset,
  ...getSchedulerEventProps(SchedulerEventType.DemandRole, {
    cls: getSchedulerEventsClass(
      SchedulerEventType.DemandRole,
      getClassNameForDemandRoleSummary(roleSummary),
    ),
  }),
});
